/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";

// @mui icons
import Icon from "@mui/material/Icon"; 
import Yojana from "layouts/yojana/components/Header";
import SubYojana from "layouts/subyojana";
import visitors from "layouts/visitors";
import VisitPage from "layouts/visitors";
import Eoffice from "layouts/eofficeTable";
import Lokshahi from "layouts/lokshahiTable";
import ApleSarkar from "layouts/authentication/apleSarkarTable";
import StaticTable from "layouts/staticTable";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "विभाग",
    key: "vibhag",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/vibhag",
    component: <Profile />,
  },
  // {
  //   type: "collapse",
  //   name: "Yojana",
  //   key: "notifications",
  //   icon: <Icon fontSize="small">notifications</Icon>,
  //   route: "/notifications",
  //   component: <Notifications />,
  // },  
  // {
  //   type: "collapse",
  //   name: "Tables",
  //   key: "tables",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/tables",
  //   component: <Tables />,
  // },
  // {
  //   type: "collapse",
  //   name: "Billing",
  //   key: "billing",
  //   icon: <Icon fontSize="small">receipt_long</Icon>,
  //   route: "/billing",
  //   component: <Billing />,
  // },
  // {
  //   type: "collapse",
  //   name: "RTL",
  //   key: "rtl",
  //   icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
  //   route: "/rtl",
  //   component: <RTL />,
  // },
 
  {
    // type: "collapse",
    // name: "Sub Yojana",
    // key: "sign-in",
    // icon: <Icon fontSize="small">login</Icon>,
    route: "/subyojana",
    component: <SubYojana/>,
  },
  {
    // type: "collapse",
    // name: "Sub Yojana",
    // key: "sign-in",
    // icon: <Icon fontSize="small">login</Icon>,
    route: "/static-table",
    component: <StaticTable/>,
  },

  {
    type: "collapse",
    name: "आपले सरकार",
    key: "aplesarkar",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "aplesarkar",
    component: <ApleSarkar />,
  },
  {
    type: "collapse",
    name: "लोकशाही दिन",
    key: "lokshahi",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "lokshahi",
    component: <Lokshahi />,
  },
  {
    type: "collapse",
    name: "e-कार्यालय",
    key: "Eoffice",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "Eoffice",
    component: <Eoffice />,
  },
  {
    type: "collapse",
    name: "संपर्क",
    key: "visitors",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/visitors",
    component: <VisitPage />,
  },
  // {
  //   type: "collapse",
  //   name: "Logout",
  //   key: "sign-up",
  //   icon: <Icon fontSize="small">assignment</Icon>,
  //   route: "/authentication/sign-up",
  //   component: <SignUp />,
  // }, 
  {
    type: "collapse",
    name: "Logout",
    key: "sign-up",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  }, 
];

export default routes;
